export const constant = {
  baseUrl: process.env.REACT_APP_BASE_URL || 'https://crm.anzianoinsuranceagency.com/'
    // baseUrl: 'https://newinsurance.onrender.com/'
}
  